export default __webpack_public_path__ + "static/media/purplestar.44c5fd69.svg";